// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"dd36a8f1","506":"ad3ac23d"}[chunkId] + ".chunk.js";
};